import {
  CalculatorActionType,
  UnitPackaging,
  LayerPatternType,
  LayerConfiguration,
  ResultsUnitSystem,
} from 'enums/calculator';
import {
  CalculatorStoreAction,
  LoadHeightState,
  PalletDataState,
  UnitDimensionsState,
  UnitWeightState,
} from 'interfaces/store';
import { LayerAlignmentItem } from 'interfaces/calculator';

export const nextStepCalculatorAction = (): CalculatorStoreAction => (
  { type: CalculatorActionType.NEXT_STEP }
);

export const prevStepCalculatorAction = (): CalculatorStoreAction => (
  { type: CalculatorActionType.PREV_STEP }
);

export const jumpToStepCalculatorAction = (
  stepIndex: number,
): CalculatorStoreAction => (
  { type: CalculatorActionType.JUMP_TO_STEP, payload: { stepIndex } }
);

export const setUnitPackagingCalculatorAction = (
  packagingType: UnitPackaging,
): CalculatorStoreAction => (
  { type: CalculatorActionType.SET_UNIT_PACKAGING, payload: { packagingType } }
);

export const setLayerConfigTypeAction = (
  layerConfigType: LayerConfiguration,
): CalculatorStoreAction => (
  { type: CalculatorActionType.SET_LAYER_CONFIG_TYPE, payload: { layerConfigType } }
);

export const setDimensionsCalculatorAction = (
  dimensions: UnitDimensionsState,
): CalculatorStoreAction => (
  { type: CalculatorActionType.SET_DIMENSIONS, payload: { dimensions } }
);

export const setWeightCalculatorAction = (
  weight: UnitWeightState,
): CalculatorStoreAction => (
  { type: CalculatorActionType.SET_WEIGHT, payload: { weight } }
);

export const setPalletDataCalculatorAction = (
  palletData: PalletDataState,
): CalculatorStoreAction => (
  { type: CalculatorActionType.SET_PALLET_DATA, payload: { palletData } }
);

export const setActiveLayerPatternAction = (
  patternId: string,
): CalculatorStoreAction => (
  { type: CalculatorActionType.LAYER_SET_ACTIVE_PATTERN, payload: { patternId } }
);

export const setLayerPatternTypeAction = (
  patternType: LayerPatternType,
): CalculatorStoreAction => (
  { type: CalculatorActionType.LAYER_SET_PATTERN_TYPE, payload: { patternType } }
);

export const setLayerUnitsAction = (
  units: number | null,
): CalculatorStoreAction => (
  { type: CalculatorActionType.LAYER_SET_UNITS, payload: { units } }
);

export const setHorizontalOverlap = (
  horizontalOverlap: number,
): CalculatorStoreAction => (
  { type: CalculatorActionType.LAYER_SET_HORIZONTAL_OVERLAP, payload: { horizontalOverlap } }
);

export const setVerticalOverlap = (
  verticalOverlap: number,
): CalculatorStoreAction => (
  { type: CalculatorActionType.LAYER_SET_VERTICAL_OVERLAP, payload: { verticalOverlap } }
);

export const set3DView = (
  view3D: boolean,
): CalculatorStoreAction => (
  { type: CalculatorActionType.VIEW_3D, payload: { view3D } }
);

export const setLoadHeightCalculatorAction = (
  height: LoadHeightState,
  dimensions: UnitDimensionsState,
): CalculatorStoreAction => (
  { type: CalculatorActionType.SET_LOAD_HEIGHT, payload: { height, dimensions } }
);

export const setResultsUnitSystemAction = (
  resultsUnitSystem: ResultsUnitSystem,
): CalculatorStoreAction => (
  { type: CalculatorActionType.SET_RESULTS_UNIT_SYSTEM, payload: { resultsUnitSystem } }
);

/* Actions to save images in the state to use them in the PDF */
export const set2DImageAction = (
  image: string,
): CalculatorStoreAction => (
  { type: CalculatorActionType.SET_2D_IMAGE, payload: { image } }
);

export const set3DImageAction = (
  image: string,
): CalculatorStoreAction => (
  { type: CalculatorActionType.SET_3D_IMAGE, payload: { image } }
);

export const setLayerAlignmentItem = (
  layerAlignmentItem: LayerAlignmentItem,
): CalculatorStoreAction => (
  { type: CalculatorActionType.SET_LAYER_ALIGNMENT_ITEM, payload: { layerAlignmentItem } }
);
